import { useMemo } from 'react';
import { createValidate, Validation, Validator } from './validation';

export const useValidate = (
  validation: Validation | Validator = {},
  validationErrorMessage: string | undefined = undefined,
) =>
  // Note: Passing objects directly in React components will make this memoization useless.
  // Potentially look into deep equality check if performance issues arise.
  useMemo(
    () =>
      typeof validation === 'function'
        ? validation
        : createValidate(validation, validationErrorMessage),
    [validation, validationErrorMessage],
  );
